export default __webpack_public_path__ + "static/media/mw6.6c01b09c.webp";